import styled from 'styled-components';

export const SessionBoxWrapper = styled.div`
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  padding: 16px 24px;
  display: grid;
  grid-template-columns: 1fr 263px;
  gap: 36px;
  margin-bottom: 24px;

  .completed {
    margin-left: 16px;
    padding-left: 16px;
    color: #03603f;
    svg {
      margin-left: 6px;
      stroke: #03603f;
    }
  }

  @media ${(props) => props.theme.device.tablet} {
    display: block;
    padding: 16px;

    .completed {
      margin-left: 0;
      padding-left: 0;
    }
  }
`;

export const MoreInfo = styled.div`
  display: flex;
  gap: 64px;

  svg {
    margin-left: 8px;
    stroke: ${({ theme }) => theme.colors.textPrimary};
  }

  @media ${(props) => props.theme.device.tablet} {
    gap: 24px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }
`;

export const Chart = styled.div`
  position: relative;
  width: 110px !important;
  height: 110px !important;

  canvas {
    width: 110px !important;
    height: 110px !important;
  }

  .registration {
    position: absolute;
    top: 43px;
    left: 55px;
    transform: translate(-50%, 0);
  }

  .max-number {
    font-size: 12.932px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const ButtonBoxWrapper = styled.div`
  min-height: 246px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.bgBox};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;

  .btn-wrapper {
    margin-top: 24px;
    @media ${(props) => props.theme.device.mobileL} {
      width: 100%;
    }

    > div {
      text-align: center;
    }
  }
`;
